export default function BoatIcon() {
  return (
    <svg
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.6667 17.4997C14.5084 17.4997 13.3501 17.108 12.3334 16.3997C10.3001 17.8247 7.70007 17.8247 5.66674 16.3997C4.65007 17.108 3.49174 17.4997 2.3334 17.4997H0.666737V19.1663H2.3334C3.4834 19.1663 4.61674 18.8747 5.66674 18.3413C7.76674 19.4163 10.2334 19.4163 12.3334 18.3413C13.3834 18.883 14.5167 19.1663 15.6667 19.1663H17.3334V17.4997H15.6667ZM2.29174 15.833H2.3334C3.66674 15.833 4.85007 15.0997 5.66674 14.1663C6.4834 15.0997 7.66674 15.833 9.00007 15.833C10.3334 15.833 11.5167 15.0997 12.3334 14.1663C13.1501 15.0997 14.3334 15.833 15.6667 15.833H15.7084L17.2834 10.2663C17.3501 10.0497 17.3334 9.81634 17.2334 9.61634C17.1334 9.41634 16.9501 9.26634 16.7334 9.19967L15.6667 8.84968V4.99967C15.6667 4.08301 14.9167 3.33301 14.0001 3.33301H11.5001V0.833008H6.50007V3.33301H4.00007C3.0834 3.33301 2.3334 4.08301 2.3334 4.99967V8.84968L1.2584 9.19967C1.04174 9.26634 0.858403 9.41634 0.758403 9.61634C0.658403 9.81634 0.633403 10.0497 0.708403 10.2663L2.29174 15.833ZM4.00007 4.99967H14.0001V8.30801L9.00007 6.66634L4.00007 8.30801V4.99967Z"
        fill="#323232"
      />
    </svg>
  );
}
